<template>
  <div class="uk-container">
    <div class="uk-margin-bottom">
      <label class="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer">
        <input
          type="checkbox"
          id="createDriver_isOwnerOperator"
          v-model="showActiveOnly"
          class="uk-checkbox"
        />
        Show active drivers only
      </label>
    </div>

    <table
      class="uk-text-small uk-table-middle uk-table uk-table-condensed uk-table-small uk-table-divide uk-table-striped uk-table-hover"
    >
      <thead>
        <tr>
          <th class="uk-text-left uk-text-normal">Name</th>
          <th class="uk-text-bold uk-text-left">Type</th>
          <th class="uk-text-left uk-text-bolder">Phone #</th>
          <th class="uk-text-left">Status</th>
          <th class="uk-text-left">Truck #</th>
          <th class="uk-table-shrink">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr 
          v-for="driver in filteredDrivers" 
          :key="driver.id" 
          @click="selectDriver(driver)"
          style="cursor: pointer;"
        >
          <td>
            <div class="tw-font-bold text-slate-900">
              {{ driver.fullName }}
            </div>
          </td>

          <td>
            {{ driver.isOwnerOperator ? 'Owner Operator' : 'Company Driver' }}
          </td>
          
          <td>{{ driver.phoneNumber }}</td>

          <td>
            <span v-if="driver.isActive" class="uk-label uk-label-success">Active</span>
            <span v-else class="uk-label uk-label-inactive">Inactive</span>
          </td>

          <td class="uk-text-left">
            {{ (driver.truck && driver.truck.length > 0) ? driver.truck[0].truckNumber : '---' }}
          </td>

          <td>
            <div class="uk-flex uk-flex-nowrap">
              <button 
                class="uk-icon-button uk-margin-small-right" 
                uk-icon="pencil"
                uk-tooltip="Edit"
                @click.stop="selectDriver(driver)"
              ></button>
              
              <button 
                class="uk-icon-button uk-text-danger" 
                uk-icon="trash" 
                uk-tooltip="Delete (Deactivate)"
                @click.stop="confirmDelete(driver)"
              ></button>
            </div>
          </td>
        </tr>
        
        <tr v-if="filteredDrivers.length === 0">
          <td colspan="6" class="uk-text-center uk-text-muted tw-py-4">
            No drivers found.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DeleteDriverMutation from '../../gql/drivers/DeleteDriver.gql'; 

export default defineComponent({
  name: 'DriversTable',
  props: {
    drivers: {
      type: Array as () => any[],
      default: () => []
    }
  },
  data() {
    return {
      selectedDriver: -1,
      showActiveOnly: true,
    };
  },
  computed: {
    filteredDrivers(): any[] {
      if (!this.drivers) return [];
      
      if (this.showActiveOnly) {
        return this.drivers.filter((x) => x.isActive);
      }
      return this.drivers;
    },
  },
  methods: {
    selectDriver(driver: any) {
      this.$emit('selectDriver', driver);
    },
    
    confirmDelete(driver: any) {
      const ok = window.confirm(
        `Are you sure you want to deactivate ${driver.fullName}?`,
      );
      if (ok) this.deleteDriver(driver.id);
    },

    async deleteDriver(id: any) {
      try {
        await (this as any).$apollo.mutate({
          mutation: DeleteDriverMutation,
          variables: {
            id: parseInt(id, 10)
          }
        });
        
        this.$emit('driver-updated');
        
      } catch (error) {
        console.error(error);
        window.alert('Failed to delete driver');
      }
    }
  },
});
</script>

<style lang="scss">
.uk-label-inactive {
  border: 1px solid black;
  background-color: #7b7b7b;
  color: white;
}
.uk-text-danger {
    color: #f0506e !important;
}
</style>